// extracted by mini-css-extract-plugin
module.exports = {"collapseBar":"style_collapseBar__9sAeN","collapseBox":"style_collapseBox__cbZex","content":"style_content__7z1Qn"};